import React, { useEffect } from "react";
import { useSortBy, useTable, usePagination } from "react-table";
import { useColumns } from "../../../shared/components/Table/utils";
import Table from "../../../shared/components/Table";
import { NoResults } from "../../../shared/svg/Svg";
import {
  getEmptyStatTableValuesAccessors,
  checkNextPage,
} from "../../../shared/utils";
import Pagination from "../../../shared/components/Pagination";

const PlayersMatchLogTable = ({
  baseClass,
  emptyResultsComponent,
  hasNextPage,
  playerData,
  page,
  statType,
  setPage,
}) => {
  const columns = useColumns(statType, playerData);
  const columnAccessors = columns[0].columns.map((el) => el?.accessor);
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    state: { sortBy },
  } = useTable(
    {
      columns,
      data:
        playerData && playerData.length > 0
          ? playerData
          : getEmptyStatTableValuesAccessors(30, columnAccessors).items,
      autoResetPage: true,
      autoResetSortBy: false,
      manualPagination: true,
      manualSortBy: true,
      disableMultiSort: true,
      disableSortRemove: true,
    },
    useSortBy,
    usePagination
  );





  return (
    <>
      <Table
        baseClass={baseClass}
        getTableBodyProps={getTableBodyProps}
        getTableProps={getTableProps}
        rows={rows}
        headerGroups={headerGroups}
        state={sortBy}
        prepareRow={prepareRow}
      />
      {rows.length < 1 ? (
        <>
          <div className="mls-c-stats__no-results">
            <NoResults size="large" />
            {emptyResultsComponent ? emptyResultsComponent : null}
          </div>
        </>
      ) : (
        <div className="mls-c-stats__pagination">
          <Pagination
            canNextPage={hasNextPage}
            updateFilter={setPage}
            page={page}
          />
        </div>
      )}
    </>
  );
};

export default PlayersMatchLogTable;
